<template>
  <cardTemplate :classCustom="'overall margin-bottom-10'">
    <template #content>
      <div
        class="header flex-row flex__between padding-bottom-10 has-border__bottom"
      >
        <div class="leftSection">
          <div class="tt theTitle theTitle__lv1"></div>
        </div>
        <div class="rightSection flex-row flex__right">
          <div class="tt theTitle">Chờ phê duyệt</div>
          <div class="tt theTitle">Chưa hoàn thành</div>
          <div class="tt theTitle">Hoàn thành</div>
          <div class="tt theTitle">Kết thúc</div>
          <div class="tt theTitle">Tạm dừng/Hủy</div>
        </div>
      </div>
      <div class="body margin-bottom-10" v-if="checkCVToiGiao()">
        <div class="item-info flex-row flex__between has-border__bottom">
          <div class="leftSection">
            <div class="theTitle theTitle__lv1">Công việc tôi giao</div>
          </div>
          <div class="rightSection flex-row flex__right">
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDaGiao['CHO_PHE_DUYET_DK'] ||
                !dataCVDaGiao['CHO_PHE_DUYET_DK'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'CHO_PHE_DUYET_DK'"
                :tableData="dataCVDaGiao['CHO_PHE_DUYET_DK']"
                @viewDetail="viewListCVDaGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDaGiao['CHO_PHE_DUYET_DK'] &&
                  dataCVDaGiao['CHO_PHE_DUYET_DK'].length === 1
                    ? viewListCVDaGiao(
                        dataCVDaGiao['CHO_PHE_DUYET_DK'][0].userDeptRoleView,
                        'CHO_PHE_DUYET_DK'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDaGiao["CHO_PHE_DUYET_DK"] || []) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDaGiao['DANG_THUC_HIEN'] ||
                !dataCVDaGiao['DANG_THUC_HIEN'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'DANG_THUC_HIEN'"
                :tableData="dataCVDaGiao['DANG_THUC_HIEN']"
                @viewDetail="viewListCVDaGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDaGiao['DANG_THUC_HIEN'] &&
                  dataCVDaGiao['DANG_THUC_HIEN'].length === 1
                    ? viewListCVDaGiao(
                        dataCVDaGiao['DANG_THUC_HIEN'][0].userDeptRoleView,
                        'DANG_THUC_HIEN'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDaGiao["DANG_THUC_HIEN"] || []) }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDaGiao['HOAN_THANH'] ||
                !dataCVDaGiao['HOAN_THANH'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'HOAN_THANH'"
                :tableData="dataCVDaGiao['HOAN_THANH']"
                @viewDetail="viewListCVDaGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDaGiao['HOAN_THANH'] &&
                  dataCVDaGiao['HOAN_THANH'].length === 1
                    ? viewListCVDaGiao(
                        dataCVDaGiao['HOAN_THANH'][0].userDeptRoleView,
                        'HOAN_THANH'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDaGiao["HOAN_THANH"] || []) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDaGiao['KET_THUC'] || !dataCVDaGiao['KET_THUC'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'KET_THUC'"
                :tableData="dataCVDaGiao['KET_THUC']"
                @viewDetail="viewListCVDaGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDaGiao['KET_THUC'] &&
                  dataCVDaGiao['KET_THUC'].length === 1
                    ? viewListCVDaGiao(
                        dataCVDaGiao['KET_THUC'][0].userDeptRoleView,
                        'KET_THUC'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDaGiao["KET_THUC"] || []) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="!dataCVDaGiao['HUY'] || !dataCVDaGiao['HUY'].length"
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'HUY'"
                :tableData="dataCVDaGiao['HUY']"
                @viewDetail="viewListCVDaGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDaGiao['HUY'] && dataCVDaGiao['HUY'].length === 1
                    ? viewListCVDaGiao(
                        dataCVDaGiao['HUY'][0].userDeptRoleView,
                        'HUY'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDaGiao["HUY"] || []) || 0 }}
              </span>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="body margin-bottom-10" v-if="checkCVDuocGiao()">
        <div class="item-info flex-row flex__between has-border__bottom">
          <div class="leftSection">
            <div class="theTitle theTitle__lv1">Công việc được giao</div>
          </div>
          <div class="rightSection flex-row flex__right">
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDuocGiao['CHO_PHE_DUYET_DK'] ||
                !dataCVDuocGiao['CHO_PHE_DUYET_DK'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'CHO_PHE_DUYET_DK'"
                :tableData="dataCVDuocGiao['CHO_PHE_DUYET_DK']"
                @viewDetail="viewListCVDuocGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDuocGiao['CHO_PHE_DUYET_DK'] &&
                  dataCVDuocGiao['CHO_PHE_DUYET_DK'].length === 1
                    ? viewListCVDuocGiao(
                        dataCVDuocGiao['CHO_PHE_DUYET_DK'][0].userDeptRoleView,
                        'CHO_PHE_DUYET_DK'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDuocGiao["CHO_PHE_DUYET_DK"] || []) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDuocGiao['DANG_THUC_HIEN'] ||
                !dataCVDuocGiao['DANG_THUC_HIEN'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'DANG_THUC_HIEN'"
                :tableData="dataCVDuocGiao['DANG_THUC_HIEN']"
                @viewDetail="viewListCVDuocGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDuocGiao['DANG_THUC_HIEN'] &&
                  dataCVDuocGiao['DANG_THUC_HIEN'].length === 1
                    ? viewListCVDuocGiao(
                        dataCVDuocGiao['DANG_THUC_HIEN'][0].userDeptRoleView,
                        'DANG_THUC_HIEN'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDuocGiao["DANG_THUC_HIEN"] || []) }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDuocGiao['HOAN_THANH'] ||
                !dataCVDuocGiao['HOAN_THANH'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'HOAN_THANH'"
                :tableData="dataCVDuocGiao['HOAN_THANH']"
                @viewDetail="viewListCVDuocGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDuocGiao['HOAN_THANH'] &&
                  dataCVDuocGiao['HOAN_THANH'].length === 1
                    ? viewListCVDuocGiao(
                        dataCVDuocGiao['HOAN_THANH'][0].userDeptRoleView,
                        'HOAN_THANH'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDuocGiao["HOAN_THANH"] || []) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDuocGiao['KET_THUC'] ||
                !dataCVDuocGiao['KET_THUC'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'KET_THUC'"
                :tableData="dataCVDuocGiao['KET_THUC']"
                @viewDetail="viewListCVDuocGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDuocGiao['KET_THUC'] &&
                  dataCVDuocGiao['KET_THUC'].length === 1
                    ? viewListCVDuocGiao(
                        dataCVDuocGiao['KET_THUC'][0].userDeptRoleView,
                        'KET_THUC'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDuocGiao["KET_THUC"] || []) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="
                !dataCVDuocGiao['HUY'] || !dataCVDuocGiao['HUY'].length
              "
            >
              <summary-card-hanh-chinh-detail
                :taskStatus="'HUY'"
                :tableData="dataCVDuocGiao['HUY']"
                @viewDetail="viewListCVDuocGiao"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  dataCVDuocGiao['HUY'] && dataCVDuocGiao['HUY'].length === 1
                    ? viewListCVDuocGiao(
                        dataCVDuocGiao['HUY'][0].userDeptRoleView,
                        'HUY'
                      )
                    : ''
                "
              >
                {{ sumTotal(dataCVDuocGiao["HUY"] || []) || 0 }}
              </span>
            </el-popover>
          </div>
        </div>
      </div>
    </template>
  </cardTemplate>
</template>


<script>
import constants from "../../constants";
import SummaryCardHanhChinhDetail from "./SummaryCardHanhChinhDetail";

export default {
  name: "summaryCardCV",
  components: {
    cardTemplate: () => import("../common/cardTemplate.vue"),
    SummaryCardHanhChinhDetail,
  },
  props: ["dataCVDaGiao", "dataCVDuocGiao"],
  data() {
    return {
      checkCVDaGiao: false,
    };
  },
  computed: {
    userRoleQLPhongHop() {
      return this.$store.getters.userDeptRoles.find(
        (item) => item.roleCode === constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP
      );
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },
  methods: {
    checkCVToiGiao() {
      return (
        (this.$store.getters.enableMenuCodes || []).indexOf(
          constants.MENU_LIST.CONGVIEC_GIAO
        ) !== -1
      );
    },
    checkCVDuocGiao() {
      return (
        (this.$store.getters.enableMenuCodes || []).indexOf(
          constants.MENU_LIST.CONGVIEC_GIAO
        ) !== -1
      );
    },
    sumTotal(dataCV) {
      return dataCV.reduce((x, y) => x + y.countCV, 0);
    },
    viewListCVDaGiao(item, status) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$router.push({
        name: "job-index-assigned",
        query: {
          delegateFilter: "all",
          taskStatuses: this.convertTaskStatus(status),
          taskStatusFilter: this.convertStatusFilter(status),
          viewType: "assigner",
        },
        params: {
          userDeptRoleId: item.id,
        },
      });
    },
    viewListCVDuocGiao(item, status) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$router.push({
        name: "job-index",
        query: {
          taskStatuses: this.convertTaskStatus(status),
          taskStatusFilter: this.convertStatusFilter(status),
          viewType: "receiver",
        },
        params: {
          userDeptRoleId: item.id,
        },
      });
    },
    convertTaskStatus(status) {
      switch (status) {
        case "CHO_PHE_DUYET_DK":
          return 0;
        case "DANG_THUC_HIEN":
          return 1;
        case "HOAN_THANH":
          return 3;
        case "KET_THUC":
          return 4;
        case "HUY":
          return [2, 5, 6];
        default:
          return null;
      }
    },
    convertStatusFilter(status) {
      switch (status) {
        case "CHO_PHE_DUYET_DK":
          return "choPheDuyet";
        case "DANG_THUC_HIEN":
          return "dangThucHien";
        case "HOAN_THANH":
          return "hoanThanh";
        case "KET_THUC":
          return "ketThuc";
        case "HUY":
          return "tamDung";
        default:
          return null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SummaryCardCongViec.vue